export default __webpack_public_path__ + "static/media/Group9273.e6d80bf5.svg";